import { render } from "./CustomFieldsOrderView.vue?vue&type=template&id=11dd1bc5"
import script from "./CustomFieldsOrderView.vue?vue&type=script&lang=js"
export * from "./CustomFieldsOrderView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__